import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import PricingRow from '../../ui/atoms/PricingRow';

/**
 * PurchasePricingPreviousPurchase component.
 * Displays the amount already paid in an exchange transaction as a credit.
 * @param {object} props - exchangedTotal
 * @param {number|string} props.exchangedTotal - Total amount already paid for the exchanged purchase
 * @returns {JSX.Element|null} Component that displays exchanged purchase credit or null if not applicable
 */
const PurchasePricingPreviousPurchase = ({ exchangedTotal }) => {
  const { t } = useTranslation('purchase');

  if (!exchangedTotal || exchangedTotal <= 0) return null;

  return (
    <>
      <div className="border border-color-gray-200/60 border-dashed" />
      <PricingRow
        label={t('label.previous_purchase')}
        price={exchangedTotal}
        hasDiscount
        priceAlignment="flex-end"
      />
    </>
  );
};

PurchasePricingPreviousPurchase.propTypes = {
  exchangedTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PurchasePricingPreviousPurchase;
